import React from "react";
import styled from "styled-components";
import ActivityImage, { InnerContainer } from "./ActivityCardComponents/ActivityImage";
import ActivityName from "./ActivityCardComponents/ActivityName";
import ActivityLocation from "./ActivityCardComponents/ActivityLocation";
import Rating from "./ActivityCardComponents/ActivityStar";
import Divider from "./ActivityCardComponents/Divider";
import ActivitySummery from "./ActivityCardComponents/ActivitySummery";
import ActivityPrice from "./ActivityCardComponents/ActivityPrice";

const ActivityCard = props => {
  return (
    <Container itemScope itemType="https://schema.org/Product">
      <Link
        target={window.innerWidth > 700 ? "_blank" : "_self"}
        itemProp="url"
        href={props.url}
        title={props.activity_name}
      >
        <ActivityImage itemProp="image" image={props.image} inView={props.inView} seller={props.best_seller} offbeat={props.off_beat} deal={props.super_deal} />
        <ActivityInfo>
          <ActivityName itemProp="name">{props.activity_name}</ActivityName>
          <ActivityLocationStar>
            <ActivityLocation
              itemProp="location"
              itemScope
              itemType="http://schema.org/Place"
              title={props.location}
            >
              {props.location}
            </ActivityLocation>
            {props.rating !== "0.0" &&
              props.review_count !== "0" && (
                <Rating
                  itemProp="aggregateRating"
                  itemScope
                  itemType="https://schema.org/AggregateRating"
                  rating={props.rating}
                  reviewCount={props.review_count}
                />
              )}
          </ActivityLocationStar>
          <Divider />
          <ActivitySummery
            startingPoint={props.starting_point}
            minBooking={props.members}
            duration={props.duration}
            nextAvailable={props.next}
          />
          <Divider />
          <ActivityPrice
            itemProp="offers"
            itemScope
            itemType="http://schema.org/Offer"
            discount={props.discount}
            oldPrice={props.old_price}
            price={props.price}
            priceFor={props.price_type}
            guaranteedDeparture={props.guaranteed_departure}
            instantBooking={props.instant_booking}
            partialPayment={props.partial_payment}
            currency={props.currency}
          />
        </ActivityInfo>
      </Link>
    </Container>
  );
};

const Container = styled.div`
  border-radius: 5px;
  background-color: #ffffff;
  margin: 0 auto 1.25rem;
  transition: transform 0.3s ease-in-out;
  overflow: hidden;

  box-shadow: 0 0 15px 0px rgba(0, 0, 0, 0.2);

  &:hover ${InnerContainer} {
    transform: scale(1.02, 1.02);
  }
`;
const Link = styled.a`
  display: block;
  width: 100%;
  height: 100%;
  text-decoration: none;
  color: #484848;

  &:hover {
    color: #484848;
    text-decoration: none;
  }
`;

const ActivityInfo = styled.div`
  padding: 0.7rem;
`;

const ActivityLocationStar = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export default ActivityCard;
